import React, { useEffect } from "react";
import { onBlankLayout } from "store/slices/themeSlice";
import { useDispatch, useSelector } from "react-redux";
import { useGetMyProfile } from "services/hooks/user/userAuthentication";
import { setIsUserLoading, setUserData, signOut } from "store/slices/authSlice";
import Loading from "components/shared-components/Loading";
import { message } from "antd";
import { useGetImagePartnership } from "services/hooks/pmk/partnership";
// import { ALL_USER_ACCESS_MENU } from "constants/KeyConstant";

const AppRoute = ({
  component: Component,
  routeKey,
  blankLayout,
  ...props
}) => {
  const dispatch = useDispatch();
  const partnershipId = useSelector(
    (state) => state?.auth?.user?.partnership?.id
  );
  const user = useSelector((state) => state?.auth?.user);
  const token = useSelector((state) => state.auth.token);

  useEffect(() => {
    const isBlank = blankLayout ? true : false;
    dispatch(onBlankLayout(isBlank));
  }, [blankLayout, dispatch]);

  const { isLoading: loadingMyProfile } = useGetMyProfile({
    enabled: Boolean(token && !blankLayout && partnershipId),
    onSuccess: (res) => {
      const isActive = res?.dataBody?.userLoggedIn?.isActive;
      if (!isActive) {
        message.error("STATUS USER TIDAK AKTIF");
        dispatch(signOut());
        return;
      }

      dispatch(setUserData({ ...user, ...res?.dataBody }));

      // view all access menu
      // dispatch(
      //   setUserData({
      //     ...user,
      //     ...res?.dataBody,
      //     accessMenuPrivilege: [...ALL_USER_ACCESS_MENU]
      //   })
      // );
    }
  });

  useGetImagePartnership({
    body: { partnershipId: partnershipId },
    enabled: Boolean(token && !blankLayout && partnershipId),
    onSuccess: (data) => {
      const logoSmallUrl = data?.dataBody?.find(
        (item) => item?.fileFolder === "COMPANY_LOGO_SMALL"
      )?.fileUrl;
      const logoUrl = data?.dataBody?.find(
        (item) => item?.fileFolder === "COMPANY_LOGO"
      )?.fileUrl;
      dispatch(setUserData({ ...user, logoSmallUrl, logoUrl }));
      dispatch(setIsUserLoading(false));
    }
  });

  if (loadingMyProfile) {
    return <Loading cover="content" />;
  }
  return <Component {...props} />;
};

export default AppRoute;
